<template>
  <!-- 新增页 -->
  <div class="addBox">
    <!-- <MyNavBar title="新增" @click-left="returnPage"></MyNavBar> -->
    <van-nav-bar
        class="mu"
        title="新增"
        left-arrow
        @click-left="returnPage"
        :fixed="true"
    />

    <div class="formBox">
      <van-form>
        <!-- fieldType
              0：文本
              1：整数
              2：下拉选择
              3：日期
              4:日期时间
              5:小数
              6:年份
              7:单位自定义下拉
              10:级联树
           -->
        <div v-for="(item, index) in addData" :key="index">
          <!-- 输入框文本 -->
          <div v-if="item.fieldType == '0'" class="fieldItem">
            <van-field
                :type="item.fieldName == 'phone' ? 'number' : 'text'"
                :required="item.nullable ? true : false"
                v-model="form[item.fieldName]"
                :label="item.showName"
                :placeholder="formatplaceholder(item)"
                input-align="right"
                @click.stop=""
                @focus="focusPaymentUnit(item.fieldName)"
                @blur="isOriginHeight = true"
            />
            <div
                v-if="item.fieldName == 'paymentUnit'"
                class="paymentUnitBox"
                v-click-outside="closeList"
            >
              <SearchList
                  v-show="showPaymentUnitList"
                  :paymentUnit="form[item.fieldName]"
                  :deptId="deptId"
                  @selectPaymentUnit="selectPaymentUnit"
              ></SearchList>
            </div>
          </div>
          <!-- 输入框整数 -->
          <van-field
              :required="item.nullable ? true : false"
              v-if="item.fieldType == '1'"
              v-model="form[item.fieldName]"
              type="digit"
              :label="item.showName"
              :placeholder="`请输入` + item.showName"
              input-align="right"
              @focus="isOriginHeight = false"
              @blur="isOriginHeight = true"
          />
          <!-- 输入框小数 -->
          <van-field
              :required="item.nullable ? true : false"
              v-if="item.fieldType == '5'"
              v-model="form[item.fieldName]"
              type="number"
              :label="item.showName"
              :placeholder="`请输入` + item.showName"
              input-align="right"
              @focus="isOriginHeight = false"
              @blur="isOriginHeight = true"
          />
          <div v-if="item.fieldType == 10">
            <van-field
                readonly
                clickable
                :required="item.nullable ? true : false"
                name="cascade"
                :label="item.showName"
                label-class="formTitle"
                input-align="right"
                v-model="form[item.fieldShowName]"
                :placeholder="`请选择` + item.showName"
                @click="cascadeChange(item)"
            />
          </div>
          <!-- 下拉选项 + 年份 -->
          <div
              v-if="
                item.fieldType == '2' ||
                item.fieldType == '7' ||
                item.fieldType == '6'
            "
          >
            <van-field
                readonly
                clickable
                :required="item.nullable ? true : false"
                name="picker"
                label-class="formTitle"
                :value="selectVaueObj[item.fieldName]"
                :label="item.showName"
                input-align="right"
                :placeholder="`请选择` + item.showName"
                @click="hanldeShowPicker(item)"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker
                  value-key="label"
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirmSelect($event)"
                  @cancel="showPicker = false"
                  :default-index="defaultIndex"
              />
            </van-popup>
          </div>
          <!-- 日期 -->
          <van-field
              v-if="item.fieldType == '3'"
              readonly
              clickable
              :required="item.nullable ? true : false"
              label-class="formTitle"
              name="picker"
              :value="form[item.fieldName]"
              :label="item.showName"
              :placeholder="`请选择` + item.showName"
              @click="openDate(item,index)"
              input-align="right"
          />
          <!-- :max-date="item.allowFutureDate?maxNow:maxDate" -->
          <van-calendar
              :ref="'calendar'+index"
              v-if="item.fieldType == '3'"
              v-model="showDate"
              @confirm="onConfirmDate"
              color="#1989fa"
              :min-date="minDate"
              :max-date="maxDateCom"
          />
          <!-- 日期时间 -->
          <van-field
              v-if="item.fieldType == '4'"
              readonly
              clickable
              :required="item.nullable ? true : false"
              label-class="formTitle"
              name="picker"
              :value="form[item.fieldName]"
              :label="item.showName"
              :placeholder="`请选择` + item.showName"
              @click="hanldeShowDateTime(item)"
              input-align="right"
          />
          <van-popup
              v-if="item.fieldType == '4'"
              v-model="showDateTimePicker"
              position="bottom"
          >
            <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="选择完整时间"
                :min-date="minDate"
                :max-date="maxDateCom"
                @confirm="onConfirmDateTime()"
                @cancel="showDateTimePicker = false"
            />
          </van-popup>

          <!-- 年月 -->
          <van-field
              v-if="item.fieldType == '9'"
              readonly
              clickable
              :required="item.nullable ? true : false"
              label-class="formTitle"
              name="picker"
              :value="form[item.fieldName]"
              :label="item.showName"
              :placeholder="`请选择` + item.showName"
              @click="hanldeShowMonth(item)"
              input-align="right"
          />
          <van-popup
              v-if="item.fieldType == '9'"
              v-model="showMonthPicker"
              position="bottom"
          >
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                :max-date="maxDateCom"
                @confirm="onConfirmMonth()"
                @cancel="showMonthPicker = false"
            />
          </van-popup>
          <!-- 上传文件-->
          <van-field
              v-if="item.fieldType == '8'"
              readonly
              :placeholder="`点击上传` + item.showName"
              :required="item.nullable ? true : false"
              label-class="formTitle"
              v-model="uploadName[item.fieldName]"
              :name="item.fieldName"
              :label="item.showName"
              @click="openFieldDialog(item)"
              input-align="right"
          />
        </div>
        <!-- <div v-if="tKeys.length > 0">
          <van-field
            v-for="(it, index) in tKeys"
            :key="index"
            v-model="form[it]"
            :label="ticketList[it]"
            :placeholder="'请输入' + ticketList[it]"
            input-align="right"
          />
        </div> -->
        <van-field
            class="totalItem"
            readonly
            v-model="totalY"
            label="总金额"
            input-align="right"
        />
      </van-form>
      <!-- <div class="total">
         <div class="addBtn" type="primary" size="small" @click="showItem">
          <img src="@/assets/img/add.png" alt="" />
          <span>添加收费项目</span>
        </div> -->
      <!-- <div>
          总金额：<span>{{ total }}元</span>
        </div>

      </div> -->
    </div>
    <div class="addBtnCenter" @click="showItem">
      <img src="../../assets/img/tyadd1.png" alt="" />
      <span>添加收费项目</span>
      <van-icon name="arrow" />
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in listData" :key="index">
        <div class="title">
          <span>[{{ item.itemCode }}]{{ item.itemName }}</span>
          <img @click="delItem(index)" src="@/assets/img/tydel.png" alt="" />
        </div>
        <div class="content">
          <div class="con_left">
            <p>数量：{{ item.biNumber }}</p>
            <p>标准：{{ item.standard }}元</p>
            <p>
              金额：<span>¥ {{ item.actualAmt }}</span>
            </p>
            <p>备注：{{ item.remark ? item.remark : "无" }}</p>
            <!-- <img src="@/assets/img/shoufei.png" alt="" /> -->
          </div>
          <div class="con_right">
            <article @click="handleEdit(item)">编辑</article>
          </div>
        </div>
      </div>
    </div>
    <div
        :class="
        showBot ||
        listData.length > 0 ||
        !isOriginHeight ||
        (screenWth <= 413 && addData.length >= 9) ||
        (screenWth > 413 && addData.length >= 7)
          ? ''
          : 'addArea'
      "
    >
      <div class="btnBox">
        <!-- <div @click="clearForm" >清除</div> -->
        <!-- <div
          @click="search"
          >查询</div
        > -->
        <van-button
            block
            @click="save"
            :disabeld="disabeledBtn"
            class="btn"
            type="info"
        >
          保存
          <img class="blueSha" src="../../assets/img/blueshadow.png" alt="" />
        </van-button>
      </div>

      <div class="notice">
        已添加未支付的历史数据，点击<span @click="toPayList">缴费信息</span>查询
      </div>
    </div>

    <van-popup v-model="show" round>
      <div class="dialog">
        <div class="title">添加收费项目</div>
        <van-form>
          <van-field
              readonly
              clickable
              name="picker"
              :value="addForm.item"
              label="收费项目"
              placeholder="点击选择收费项目(必填)"
              @click="showPickerThree = true"
              input-align="right"
              required
          />
          <van-field
              v-model="addForm.biNumber"
              name="数量"
              label="数量"
              type="number"
              placeholder="请输入数量"
              input-align="right"
          />
          <van-field
              v-model="addForm.standard"
              name="标准"
              label="标准"
              type="number"
              :disabled="disabled"
              placeholder="请输入标准"
              input-align="right"
          />
          <van-field
              v-model="addForm.actualAmt"
              name="金额"
              label="金额"
              placeholder="请输入金额"
              input-align="right"
              disabled
          />
          <van-field
              v-model="addForm.remark"
              name="备注"
              label="备注"
              placeholder="请输入备注"
              input-align="right"
          />
        </van-form>
        <div class="btnBox">
          <div @click="show = false">取消</div>
          <div @click="saveItem">确定</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showPickerThree" position="bottom">
      <van-picker
          show-toolbar
          :columns="chargingItemTree"
          @confirm="onConfirmInner"
          @cancel="showPickerThree = false"
      />
    </van-popup>
    <!-- 上传文件组件 -->
    <UploadDialog
        :showDialog="showUploadDialog"
        :selectField="selectItem"
        :deptId="deptId"
        @close="closeUpload"
        :selectFiled="uploadFiledsObj[selectItem.fieldName]"
    ></UploadDialog>
  </div>
</template>

<script>
import {Notify, Dialog, DatetimePicker, Toast} from "vant";
import {
  formatterDate,
  formatterSureDate,
  isEmpty,
  getUser,
  fixNum,
  fixNewNum
} from "../../utils/common";
import selectPicker from "@/components/selectPicker";
import UploadDialog from "@/components/uploadDialog.vue";
import NoticeDialogLogin from "../noticePublic/noticeDialogLogind.vue";
import SearchList from "@/components/list/searchList";
import BigNumber from "bignumber.js";

export default {
  components: {
    selectPicker,
    UploadDialog,
    NoticeDialogLogin,
    SearchList
  },
  computed: {
    fifthList() {
      return this.$store.state.notice.fifData;
    },
    totalY() {
      return "¥ " + this.total;
    }
  },
  data() {
    return {
      showPickDtype: false,
      defaultValue: "",
      ticketList: {},
      tKeys: [], // 保存票据信息的keys
      form: {}, //表单值
      addData: [], //表单渲染
      showPicker: false,
      columns: [], //下拉选项
      selectItem: {}, //下拉选中对象
      selectVaueObj: {}, //下拉value值
      addForm: {
        item: "",
        biNumber: "",
        standard: "",
        actualAmt: "",
        isEdit: "",
        itemName: "",
        itemCode: "",
        itemId: "",
        remark: "",

      },

      listData: [], //列表

      showPickerThree: false,
      show: false, //弹框展示
      listSysType: [], //业务类型
      chargingItemTree: [], //弹窗内选择器
      disabled: false, //标准是否可选
      total: "0.00",
      vde: "",
      showDate: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(2030, 10, 1),
      maxNow:new Date(),
      currentDate: "",
      showDateTimePicker: false,
      defaultIndex: 0,
      deptId: JSON.parse(sessionStorage.getItem("user")).deptId,
      idLabel: "",
      isConfigIdtype: false,
      disabeledBtn: false,
      fixNum: fixNum(),
      fixNewNum: fixNewNum(),
      showUploadDialog: false,
      uploadName: {}, //上传时输入框显示的名字
      uploadFiledsObj: {},
      userName: "",
      showPaymentUnitList: false,
      checkDindex: -1,
      screenHeight: document.documentElement.clientHeight, // 当前高度
      originHeight: document.documentElement.clientHeight, //默认高度，用作比较
      isOriginHeight: true, //当
      screenWth: "",
      showBot: "",
      showMonthPicker:false,
      maxDateCom:new Date(),
      limit:0,
    };
  },
  watch: {
    tKeys(val) {
      if (val.length + this.addData.length >= 9) {
        this.showBot = true;
      } else {
        this.showBot = false;
      }
    },
    screenHeight(val) {
      if (this.originHeight - val > 60) {
        //这里以防万一改了下判断形式，当屏幕高度减少了60px以上时才隐藏footer
        this.isOriginHeight = false;
      } else {
        this.isOriginHeight = true;
      }
    },
    addForm: {
      // 深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        if (val.biNumber > 0 && val.standard > 0) {

          const total=BigNumber(val.standard).multipliedBy(val.biNumber).toNumber().toFixed(2)

          val.actualAmt =total
        } else {
          val.actualAmt = "0.00";
        }
      },
      deep: true
    }
  },
  async created() {
    if (this.$route.query.vde === undefined) {
      this.vde = "";
    } else {
      this.vde = this.$route.query.vde;
    }
    this.request({
      url: '/sysFunConfig/getSysFunConfigInput?type=53&deptId=' + this.vde,
      method: 'get',
    }).then((res) => {
      if (res.data.code == 1000) {
        this.limit = res.data.message || 6
      }
    })
    this.getAddData();
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        this.screenHeight = window.fullHeight;
      })()
    };
    this.screenWth = document.documentElement.clientWidth;
    let iType = "";
    iType = localStorage.getItem("iType");
    if (localStorage.getItem("dTypes")) {
      let types = JSON.parse(localStorage.getItem("dTypes"));
      if (types && types.length > 0) {
        types.forEach(item => {
          if (item.value == iType) {
            this.selectVaueObj.dataType = item.label;
          }
        });
      }
    }
    if (localStorage.getItem("addInfo")) {
      let obj = JSON.parse(localStorage.getItem("addInfo"));
      console.log(obj)
      this.form.dataType = obj.dataType;
      this.form.billBankAccount =  obj.billBankAccount
      this.form.billOpenBank =  obj.billOpenBank

      this.getTicketMess();
    }
  },
  methods: {
    cascadeChange(item){
      localStorage.setItem("listItem", JSON.stringify(this.listData));
      localStorage.setItem("addInfo", JSON.stringify(this.form));
      localStorage.setItem("iType", this.form.dataType);
      this.$router.push({
        path:'/login/cascadeTree',
        query:{
          uId:item.dictionary,
          fieldName:item.fieldName,
          fieldShowName:item.fieldShowName
        }
      })
    },
    formatplaceholder(str) {
      // console.log(str);
      if (str.showName == "缴款单位/人") {
        return `请输入单位或个人名称`;
      } else {
        return `请输入${str.showName}`;
      }
    },
    returnPage() {
      localStorage.removeItem("listItem");
      localStorage.removeItem("addInfo");
      localStorage.removeItem("iType");
      this.$router.go(-1);
    },
    // 去通知详情页查看通知
    toDetail() {
      // sessionStorage.setItem("noticeMessage",JSON.stringify(obj));
      this.$router.push({
        path: "/noticeDet",
        query: {
          id: this.fifthList[0].id
        }
      });
    },
    // 获取新增数据
    getAddData() {
      return new Promise(resolve => {
        this.request({
          url: "/busFieldConfig/listBusFieldConfiged",
          method: "get",
          params:{
            deptId:this.deptId
          }
        }).then(res => {
          if (res && res.data && res.data.code == 1000) {
            this.addData = JSON.parse(JSON.stringify(res.data.result));
            this.addData.forEach(item => {
              if (
                  item.fieldName == "dataType" &&
                  localStorage.getItem("iType")
              ) {
                this.$set(
                    this.form,
                    item.fieldName,
                    localStorage.getItem("iType")
                );
              } else {
                this.$set(this.form, item.fieldName, item.defaultValue);
              }

              if (item.fieldType == "2") {
                if (item.dictionary == "sys_capital_property") {
                  this.getCapitalProperty().then(result => {
                    if (!isEmpty(result)) {
                      result.forEach(val => {
                        if (this.form[item.fieldName] == val.value) {
                          this.$set(
                              this.selectVaueObj,
                              item.fieldName,
                              val.label
                          );
                        }
                      });
                    }
                    this.$set(item, "options", result);
                    item.options.forEach(vals => {
                      if (
                          localStorage.getItem("iType") &&
                          item.fieldName == "dataType"
                      ) {
                        // if ( localStorage.getItem("iType")== vals.value) {
                        //   this.selectVaueObj.dataType = vals.label;
                        //   this.form.dataType = item.defaultValue;
                        //   this.getDefault();
                        //   localStorage.removeItem('iType');
                        // }else{
                        //   if (item.defaultValue == vals.value) {
                        //     this.selectVaueObj.dataType = vals.label;
                        //     this.form.dataType = item.defaultValue;
                        //     this.getDefault();
                        //   }
                        // }
                        if (localStorage.getItem("iType") == vals.value) {
                          this.selectVaueObj.dataType = vals.label;
                          this.form.dataType = vals.value;
                          if (localStorage.getItem("listItem")) {
                          } else {
                            this.getDefault();
                          }
                        }
                      } else {
                        if (item.defaultValue == vals.value) {
                          this.selectVaueObj.dataType = vals.label;
                          this.form.dataType = item.defaultValue;
                          if (localStorage.getItem("listItem")) {
                          } else {
                            this.getDefault();
                          }
                        }
                      }
                    });
                  });
                } else {
                  let url =
                      "/system/dictionary/listDictData/" + item.dictionary;
                  let data = {};
                  this.getDictionaryData(url, data).then(result => {
                    if (!isEmpty(result)) {
                      result.forEach(val => {
                        if (item.fieldName == "dataType") {
                          localStorage.removeItem("iType");
                        }
                        if (this.form[item.fieldName] == val.value) {
                          this.$set(
                              this.selectVaueObj,
                              item.fieldName,
                              val.label
                          );
                        }
                      });
                    }
                    this.$set(item, "options", result);
                  });
                }
              }
              if (item.fieldType == "7") {
                let url = "/system/dictDeptData/listDictDeptData";
                let data = { deptId: this.deptId, dictType: item.dictionary };
                this.getDictionaryData(url, data).then(result => {
                  result.forEach(val => {
                    if (this.form[item.fieldName] == val.value) {
                      this.$set(this.selectVaueObj, item.fieldName, val.label);
                    }
                  });
                  this.$set(item, "options", result);
                });
              }
              if (item.fieldType == "6") {
                this.$set(
                    this.selectVaueObj,
                    item.fieldName,
                    item.defaultValue
                );
                this.$set(item, "options", this.getYearArray(item));
                if(localStorage.getItem('addInfo')){
                  let obj = JSON.parse(localStorage.getItem('addInfo'))
                  this.selectVaueObj[item.fieldName] = obj[item.fieldName]
                }
              }
              if(item.fieldType == '10'){
                item.fieldShowName = item.fieldName + 'show'
                if(this.addData[item.fieldShowName] == undefined){
                  let str = ''
                  this.request({
                    url: '/deptCascadeDictData/listDeptCascadeDictDataTree',
                    params: {
                      dictId: item.dictionary
                    }
                  }).then(res => {
                    if(res.data.result.length){
                      let data = this.flattenTree(res.data.result)
                      data && data.map(it => {
                        if (it.uId == this.form[item.fieldName]) {
                          this.$nextTick(() => {
                            // this.form[item.fieldName + 'show']  = it.dictName
                            this.$set(this.form,item.fieldName + 'show',it.dictName)
                          })
                        }
                      })
                    }
                  })
                }
              }
              this.form[item.fieldName] = this.form[item.fieldName]
                  ? this.form[item.fieldName]
                  : "";
            });
            this.isConfigIdtype = this.addData.some(item => {
              return item.dictionary == "sys_id_type";
            });
            if (this.isConfigIdtype) {
              this.addData.find(item => {
                if (item.dictionary == "sys_id_type") {
                  this.idLabel = item.fieldName;
                }
              });
            }
            this.total = 0;
            if (localStorage.getItem("listItem")) {
              this.listData = JSON.parse(localStorage.getItem("listItem"));
              let iType = "";
              this.listData.forEach(item => {
                this.total += Number(item.actualAmt);
              });
              iType = localStorage.getItem("iType");
              if (localStorage.getItem("dTypes")) {
                let types = JSON.parse(localStorage.getItem("dTypes"));
                if (types && types.length > 0) {
                  types.forEach(item => {
                    if (item.value == iType) {
                      this.selectVaueObj.dataType = item.label;
                      // this.selectVaueObj.dataType =iType;
                    }
                  });
                }
              }
              this.form.dataType = iType ? iType : this.$route.query.dataType;
              this.total = Number(this.total).toFixed(2);
              // localStorage.removeItem("listItem");
            }
            if (localStorage.getItem("addInfo")) {
              this.form = JSON.parse(localStorage.getItem("addInfo"));
              console.log( this.form )
              localStorage.removeItem("addInfo");
            }
          }
          resolve();
        });
      });
    },
    flattenTree(tree) {
      let result = []; // 存放最后的扁平化数组

      function traverseNode(node) {
        if (Array.isArray(node)) {
          node.forEach((child) => {
            traverseNode(child);
          });
        } else {
          result.push(node);

          if (node.children && Array.isArray(node.children)) {
            node.children.forEach((child) => {
              traverseNode(child);
            });
          }
        }
      }

      traverseNode(tree);

      return result;
    },
    getDictionaryData(url, data) {
      return this.request({
        url: url,
        method: "get",
        params: data
      }).then(res => {
        if (res.data.code == 1000) {
          return res.data.result;
        }
      });
    },
    // 获取资金性质
    getCapitalProperty() {
      return new Promise(resolve => {
        this.request({
          url:
              "/capitalDeptConfig/listCapitalPropertyExt/" +
              localStorage.getItem("vde"),
          method: "get"
        }).then(res => {
          if (res.data.code == 1000) {
            localStorage.setItem("dTypes", JSON.stringify(res.data.result));
            resolve(res.data.result);
          }
        });
      });
    },
    // 获取年份数组
    getYearArray(item) {
      // 先判断是否允许录入未来日期
      const date = new Date();
      let currentYear;
      if(item.allowFutureDate){
        currentYear = date.getFullYear()
      }else{
        currentYear = date.getFullYear() + 10;
      }
      const yearArray = [];
      // 入学年度，最多录入当年的
      const lastYear = currentYear;
      for (let i = lastYear; i >= 1900; i--) {
        let obj = {
          value: i.toString(),
          label: i.toString()
        };
        yearArray.push(obj);
      }
      return yearArray;
    },
    // 打开日期
    openDate(item,idx) {
      this.selectItem = item;
      // maxDate
      // console.log(this.$refs.calendar)
      // if(this.$refs['calendar'+idx]){
      if(item.allowFutureDate){
        this.maxDateCom=this.maxNow;
      }else{
        this.maxDateCom=this.maxDate;
      }
      // }
      this.showDate = true;
    },
    onConfirmDate(val) {
      this.form[this.selectItem.fieldName] = formatterDate(val);
      this.showDate = false;
    },

    hanldeShowPicker(item) {
      this.selectItem = item;
      this.columns = item.options;
      this.columns.forEach((val, index) => {
        if (this.selectVaueObj[item.fieldName] == val.label) {
          this.defaultIndex = index;
        }
      });
      this.showPicker = true;
    },
    selDType(index) {
      localStorage.removeItem("iType");
      localStorage.removeItem("listItem");
      this.checkDindex = index;
      let label = this.columns.find(i => i.value == this.columns[index].value)
          .label;
      this.selectVaueObj[this.selectItem.fieldName] = label; //'非税'
      // console.log("选中", item, label);
      this.form[this.selectItem.fieldName] = this.columns[index].value;
      if (this.selectItem.fieldName == "dataType") {
        //update by wxr on 2021.07.14 若选中的资金性质，则清空当前选中的收费项目
        this.listData = [];

        this.getDefault();

        // 根据选择的资金性质获取到开票信息
        this.getTicketMess();
      }
      this.showPickDtype = false;
    },
    onConfirmPicker(item) {
      let label = this.columns.find(i => i.value == item).label;
      this.selectVaueObj[this.selectItem.fieldName] = label; //'非税'
      this.form[this.selectItem.fieldName] = item;
      if (this.selectItem.fieldName == "dataType") {
        //update by wxr on 2021.07.14 若选中的资金性质，则清空当前选中的收费项目
        this.listData = [];
        this.getDefault();
        // 根据选择的资金性质获取到开票信息
        this.getTicketMess();
      }
      this.showPicker = false;
    },
    // 数据字典选择器点击确定
    onConfirmSelect(val) {
      console.log(val)
      this.selectVaueObj[this.selectItem.fieldName] = val.label; //'非税
      const dType = this.form.dataType;
      this.form[this.selectItem.fieldName] = val.value;

      if (this.selectItem.fieldName == "dataType") {
        //update by wxr on 2021.07.14 若选中的资金性质，则清空当前选中的收费项目
        this.listData = [];
        if(dType!=this.form.dataType){
          console.log(1)
          this.getDefault();
        }else{
          console.log(2)
          if(localStorage.getItem("listItem")){
            this.listData=JSON.parse(localStorage.getItem('listItem'))
          }
        }
        // 根据选择的资金性质获取到开票信息
        this.getTicketMess();
      }
      // }
      this.showPicker = false;
    },
    getTicketMess() {
      this.request({
        url: "/business/getH5BillField",
        method: "post",
        params: {
          dataType: this.form.dataType,
          deptId: this.deptId
        }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result) {
            this.ticketList = res.data.result;
            if (this.tKeys.length > 0) {
              this.tKeys.forEach(it => {
                if (this.form[it] != undefined) {
                  delete this.form[it];
                }
              });
            }
            this.tKeys = Object.keys(this.ticketList);
            for (var i in res.data.result) {
              this.$set(this.form, i, "");
            }
          }
        }
      });
    },
    // 打开时间日期
    hanldeShowDateTime(item) {
      this.selectItem = item;
      this.showDateTimePicker = true;
      if(item.allowFutureDate){
        this.maxDateCom=this.maxNow;
      }else{
        this.maxDateCom=this.maxDate;
      }
      if(this.form[this.selectItem.fieldName]){
        this.currentDate = new Date(this.form[this.selectItem.fieldName]);
      }else{
        this.currentDate = new Date();
      }
    },
    hanldeShowMonth(item){
      this.selectItem = item;
      this.showMonthPicker = true;
      if(item.allowFutureDate){
        this.maxDateCom=this.maxNow;
      }else{
        this.maxDateCom=this.maxDate;
      }
      if(this.form[this.selectItem.fieldName]){
        this.currentDate = new Date(this.form[this.selectItem.fieldName]);
      }else{
        this.currentDate = new Date();
      }
    },
    // 月份点击确定
    onConfirmMonth() {
      let year=this.currentDate.getFullYear()
      let month=this.currentDate.getMonth()+1
      if(month<=9){
        month='0'+month;
      }
      this.form[this.selectItem.fieldName] =`${year}-${month}`;
      this.showMonthPicker = false;
    },
    // 时间日期点击确定
    onConfirmDateTime() {
      this.form[this.selectItem.fieldName] = formatterSureDate(
          this.currentDate
      );
      this.showDateTimePicker = false;
    },
    onConfirmInner(value) {
      if (value) {
        this.addForm.item = value.text;
        this.addForm.biNumber = value.biNumber;
        this.addForm.actualAmt = value.actualAmt;
        this.addForm.isEdit = value.isEdit;
        this.addForm.itemName = value.itemName;
        this.addForm.itemCode = value.itemCode;
        this.addForm.itemId = value.itemId;
        this.addForm.remark = value.remark;
        this.addForm.standard = value.standard;
        if (value.isEdit == 1) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
      this.showPickerThree = false;
    },
    beforeClose(action, done) {
      if (action == "confirm") {
        done(false);
      } else {
        done();
      }
    },

    // 上传文件操作---------------------start
    // 打开选择文件
    openFieldDialog(item) {
      this.showUploadDialog = true;
      this.selectItem = item;
    },
    //关闭上传文件弹窗
    closeUpload(info) {
      this.showUploadDialog = false;
      if (info.value.length > 0) {
        this.$set(
            this.uploadName,
            info.fieldName,
            "已上传" + info.value.length + "个文件"
        );
      }
      this.form[info.fieldName] = JSON.stringify(info.value);
      let filedLists = JSON.parse(JSON.stringify(info.value));
      let arr = [];
      filedLists.forEach(item => {
        let obj = {
          url: item.fileUrl,
          name: item.fileName
        };
        arr.push(obj);
      });
      this.$set(this.uploadFiledsObj, info.fieldName, arr);
    },
    // 上传文件操作---------------------end
    save() {
      let bool = false;
      for (let i = 0; i < this.addData.length; i++) {
        if (
            this.addData[i].nullable &&
            this.form[this.addData[i].fieldName] == ""
        ) {
          // Notify({ type: "danger", message: "请填写" + item.showName });
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: "请填写" + this.addData[i].showName
          }).then(res => {});
          bool = true;
          break;
        }
      }
      if (bool) return;
      let testPhone = /^1\d{10}$/;
      let testIdCard = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!testPhone.test(this.form.phone) && !isEmpty(this.form.phone)) {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "联系电话格式不正确"
        }).then(res => {});
        return;
      } else if (this.total == 0) {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "收费总金额不能为0"
        }).then(res => {});
        return;
      } else if (
          !isEmpty(this.form.billPhone) &&
          !testPhone.test(this.form.billPhone)
      ) {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "开票联系电话格式不正确"
        }).then(res => {});
        return;
      } else if(this.form.idType=='01'&&!isEmpty(this.form.idCard) &&
          !testIdCard.test(this.form.idCard)){
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "证件号码格式不正确"
        }).then(res => {});
        return;
      }

      if (String(this.total).length > 12) {
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "总金额大于999999999.99，请修改标准金额或数量"
        }).then(res => {});
        return;
      }

      if(this.listData.length > this.limit){
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: `单条缴费数据最多选择${this.limit}个收费项目`
        })
      }else{
        let data = JSON.parse(JSON.stringify(this.form));
        data.items = [];
        this.listData.forEach(item => {
          let obj = {
            itemCode: item.itemCode,
            itemName: item.itemName,
            standard: item.standard,
            remark: item.remark,
            itemId: item.uId ? item.uId : item.itemId,
            biNumber: item.biNumber,
            actualAmt: item.actualAmt
          };
          data.items.push(obj);
        });
        data.paymentTotal = this.total;
        data.h5 = true;
        data.applicableScene = "1";

        // data
        this.disabeledBtn = true;
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0
        });
        this.request({
          url: "/business/addBusiness",
          method: "post",
          data: data
        }).then(res => {
          this.disabeledBtn = false;
          Toast.clear();
          if (res.data.code == 1000) {
            this.form.idCard = this.form.idCard ? this.form.idCard : "";
            this.form.phone = this.form.phone ? this.form.phone : "";
            Notify({ type: "success", message: "保存成功" });
            if (localStorage.getItem("listItem")) {
              localStorage.removeItem("listItem");
            }
            this.$router.push({
              path:
                  "/bussiess/payList?idCard=" +
                  this.form.idCard +
                  "&paymentUnit=" +
                  this.form.paymentUnit +
                  "&phone=" +
                  this.form.phone +
                  "&type=0&isAdd=1&vde=" +
                  this.vde
            });
            this.getAddData();
            this.listData = [];
          } else {
            if (!res.data.errorMessage) {
              // Dialog.alert({
              //   title: "错误提示",
              //   message: res.data.message,
              // }).then(() => {});
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                status: "2",
                textSize: 16,
                message: res.data.message
              }).then(res => {});
            }
          }
        });
      }

    },
    // 默认数据
    getDefault() {
      this.request({
        url: "/busEduConfig/getItemConfig",
        method: "get",
        params: { itemType: this.form.dataType }
      }).then(res => {
        if (res.data.code == 1000) {
          if (res.data.result == null || res.data.result.length == 0) {
            if (!localStorage.getItem("listItem")) {
              this.total = "0.00";
            } else {
              localStorage.removeItem("listItem");
            }
            return;
          }
          this.total = 0;
          if (this.listData && this.listData.length > 0) {
            // this.listData
            let arr = [];
            res.data.result.forEach(it => {
              let falg = true;
              falg = this.listData.some(item => {
                console.log(item.itemId, it.uId);
                if (item.itemId) {
                  return item.itemId == it.uId;
                } else {
                  return item.uId == it.uId;
                }
              });
              if (!falg) {
                arr.push(it);
              }
            });
            this.listData = this.listData.concat(arr);
            console.log(this.listData);
            this.listData.forEach(item => {
              item.standard = Number(item.standard).toFixed(fixNum());
              this.$set(
                  item,
                  "biNumber",
                  item.biNumber ? item.biNumber : "1.00"
              );

              this.$set(
                  item,
                  "actualAmt",
                  BigNumber(item.standard).multipliedBy(item.biNumber).toNumber().toFixed(2)

              );
              console.log(item.actualAmt)
              this.total += Number(item.actualAmt);
            });
          } else {
            this.listData = res.data.result;
            this.listData.forEach(item => {
              item.standard = Number(item.standard).toFixed(fixNum());
              this.$set(
                  item,
                  "biNumber",
                  item.biNumber ? item.biNumber : "1.00"
              );

              this.$set(
                  item,
                  "actualAmt",
                  BigNumber(item.standard).multipliedBy(item.biNumber).toNumber().toFixed(2)

              );
              console.log( BigNumber(item.standard).multipliedBy(item.biNumber).toNumber().toFixed(2))

              this.total += Number(item.actualAmt);
            });
          }
          this.total = Number(this.total).toFixed(2);
        }
      });
    },
    // 保存收费项目选择
    saveItem() {
      if (this.addForm.item == "") {
        Notify({ type: "danger", message: "请填写收费项目" });
      } else if (this.addForm.biNumber == "" || this.addForm.biNumber == 0) {
        Notify({ type: "danger", message: "请填写收费数量" });
      } else if (this.addForm.standard == "" || this.addForm.standard == 0) {
        Notify({ type: "danger", message: "请填写收费标准" });
      } else if (this.addForm.actualAmt == "" || this.addForm.actualAmt == 0) {
        Notify({ type: "danger", message: "收费金额不能为0" });
      } else {
        let obj = JSON.parse(JSON.stringify(this.addForm));
        let bool =
            this.listData &&
            this.listData.some(val => {
              return val.itemId == obj.itemId || val.uId == obj.itemId;
            });
        if (bool) {
          Notify({ type: "danger", message: "不能选择同一收费项目" });
        } else {
          this.total = 0;
          this.listData.push(obj);
          this.listData.forEach(item => {
            this.total += Number(item.actualAmt);
          });
          this.total = Number(this.total).toFixed(2);
          this.show = false;
        }
      }
    },
    // 删除收费项
    delItem(index) {
      this.$CDialog({
        confirmBtnText: "确认", //按钮文字
        title: "提示", //title提示文字
        message:
            "确定删除[" +
            this.listData[index].itemCode +
            "]" +
            this.listData[index].itemName +
            "?", //弹窗内容
        status: "2", //显示哪种图   1 为绿色   2为蓝色
        textSize: "16", // 字体大小，默认12
        cancelBtnText: "取消"
      })
          .then(res => {
            this.listData.splice(index, 1);
            this.total = 0;
            this.listData.forEach(item => {
              this.total += Number(item.actualAmt);
            });
            this.total = Number(this.total).toFixed(2);
          })
          .catch(rs => {});
      // Dialog.confirm({
      //   title: "提示",
      //   message:
      //     "确定删除[" +
      //     this.listData[index].itemCode +
      //     "]" +
      //     this.listData[index].itemName +
      //     "?",
      // })
      //   .then(() => {
      //     this.listData.splice(index, 1);
      //     this.total = 0;
      //     this.listData.forEach((item) => {
      //       this.total += Number(item.actualAmt);
      //     });
      //     this.total = Number(this.total).toFixed(2);
      //   })
      //   .catch(() => {});
    },
    handleEdit(item) {
      localStorage.setItem("editItem", JSON.stringify(item));
      localStorage.setItem("listItem", JSON.stringify(this.listData));
      localStorage.setItem("addInfo", JSON.stringify(this.form));
      localStorage.setItem("iType", this.form.dataType);
      this.$router.push({
        path: "/login/addItem",
        query: {
          dataType: this.form.dataType,
          vde: this.vde
        }
      });
    },
    showItem() {
      if (this.form.dataType === "") {
        // Dialog.alert({
        //   title: "错误提示",
        //   message: "请先选择资金性质",
        // }).then(() => {});
        this.$CDialog({
          confirmBtnText: "确认",
          title: "提示",
          status: "2",
          textSize: 16,
          message: "请先选择资金性质"
        }).then(res => {});
        return;
      } else {
        // this.show = true;
        // 跳转页面

        // this.addForm.item = "";
        // this.addForm.biNumber = "";
        // this.addForm.standard = "";
        // this.addForm.actualAmt = "";
        // this.addForm.isEdit = "";
        // this.addForm.itemName = "";
        // this.addForm.itemCode = "";
        // this.addForm.itemId = "";
        // this.addForm.remark = "";
        // this.listItemByDeptId();
        localStorage.setItem("listItem", JSON.stringify(this.listData));
        localStorage.setItem("addInfo", JSON.stringify(this.form));
        localStorage.setItem("iType", this.form.dataType);
        this.$router.push({
          path: "/login/addItem",
          query: {
            dataType: this.form.dataType,
            vde: this.vde
          }
        });
      }
    },
    listItemByDeptId() {
      const data = { deptId: "", itemType: this.form.dataType };
      this.request({
        url: "/deptItemConfig/listItemByDeptId",
        method: "get",
        params: data
      }).then(res => {
        if (res.data.code === 1000) {
          if (res.data.result) {
            this.chargingItemTree = res.data.result;
          }
          const itemArr = [];
          this.chargingItemTree.forEach(item => {
            const list = {};
            list.itemCode = item.attributes.itemCode;
            list.itemName = item.label;
            list.standard = (item.attributes.standard
                    ? item.attributes.standard
                    : 0
            ).toFixed(fixNum());
            list.isEdit = item.attributes.isEdit;
            list.remark = item.attributes.remark;
            list.itemId = item.value;
            list.biNumber = "1.00";




            list.actualAmt = BigNumber(list.standard).multipliedBy(list.biNumber).toNumber().toFixed(2);
            list.text = `[${list.itemCode}]${item.label}`;
            itemArr.push(list);
          });
          this.chargingItemTree = itemArr;
        }
      });
    },
    // 去列表页
    toPayList() {
      let bool = false;
      this.addData.find(item => {
        if (item.nullable && this.form[item.fieldName] == "") {
          Notify({ type: "danger", message: "请填写" + item.showName });
          bool = true;
        }
      });
      if (bool) return;
      this.$router.push({
        path: "/bussiess/payList",
        query: {
          idCard: this.form.idCard ? this.form.idCard : "",
          paymentUnit: this.form.paymentUnit,
          phone: this.form.phone ? this.form.phone : "",
          vde: this.vde
        }
      });
    },
    focusPaymentUnit(fieldName) {
      this.isOriginHeight = false;
      if (fieldName == "paymentUnit") {
        this.showPaymentUnitList = true;
      }
    },
    closeList() {
      this.showPaymentUnitList = false;
    },
    selectPaymentUnit(item) {
      this.form.paymentUnit = item.paymentUnit;
      this.showPaymentUnitList = false;
    }
  }
};
</script>

<style lang='scss' scoped>
::v-deep .van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}
@media screen and (max-width: 500px) {
  .addArea {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 8px;
    // padding-top: calc(20vh);
  }
  .van-form {
    // max-height: 62vh !important;
  }
}
@media screen and (min-width: 605px) {
  .addArea {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 8px;
  }
}
.addBox {
  position: relative;
  min-height: 100vh;
  background: #efefef;
  padding-top: 46px;
  box-sizing: border-box;
  ::v-deep .van-calendar__confirm{
    height: 44px;
    font-size: 16px;
  }
  .mu{
    z-index: 100;
  }
  ::v-deep .van-icon{
    color: #666 !important;
  }

  ::v-deep .van-nav-bar__title{
    color: #333 !important;
  }
  ::v-deep .van-picker-column__item {

    font-size: 18px;
    color: rgba(70, 74, 76, 0.7);
    letter-spacing: 0;
    font-weight: 400;
  }
  ::v-deep .van-picker-column__item--selected {

    font-size: 20px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-picker__cancel {

    font-size: 16px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 500;
  }
  ::v-deep .van-picker__confirm {

    font-size: 16px;
    color: #208fff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .addBtn {
    width: 345px;
    height: 50px;
    border-radius: 10px;
    background: #fff;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    > img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    span {

      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .addBtnCenter {
    width: 345px;
    height: 50px;
    border-radius: 10px;
    background: #fff;
    margin: 10px auto;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;
    // justify-content: center;
    align-items: center;
    ::v-deep .van-icon-arrow {
      position: absolute;
      right: 16px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.3);
    }
    > img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
    span {

      font-size: 16px;
      color: #464a4c;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .active {
    color: #1989fa;
  }
  .listBox {
    padding-left: 30px;
    height: 65%;
    overflow: auto;
    padding-top: 20px;
    .van-radio,
    .van-checkbox {
      margin: 15px;
      font-size: 15px;
      color: #333333;
    }
  }
  .btn {
    position: absolute;
    // bottom: 10px;
    width: 101px;
    height: 40px;
    background: #1989fa;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    margin-left: 260px;
  }
  .formBox {
    ::v-deep .van-field__control::-webkit-input-placeholder {

      font-size: 16px;
      color: #cccccc;
      letter-spacing: 0;
      text-align: right;
      font-weight: 400;
    }
    width: 345px;
    border-radius: 10px;
    background: #fff;
    padding: 0px 20px;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 10px;
    // .van-form {
    //   position: relative;
    //   left: 50%;
    //   margin-left: -47vw;
    //   .van-cell {
    //     border-bottom: 1px solid #eaeaea;
    //     ::v-deep .van-cell__title {
    //       color: #777;
    //     }
    //   }
    // }
    .van-form {
      // max-height: 62vh;
      // overflow: scroll;
      .van-cell {
        border-bottom: 1px solid #eee;
        ::v-deep .van-cell__title {

          font-size: 16px;
          color: #464a4c;
          letter-spacing: 0;
          line-height: 22px;
          font-weight: 400;
        }
      }
      ::v-deep .van-cell__value {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
      ::v-deep .van-field__control {

        font-size: 16px;
        color: #464a4c;
        letter-spacing: 0;
        text-align: right;
        font-weight: 500;
      }
      ::v-deep .van-field__control::-webkit-input-placeholder {

        font-size: 16px;
        color: #cccccc;
        letter-spacing: 0;
        font-weight: 400;
      }
      ::v-deep .van-cell::after {
        border-bottom: none !important;
      }
      .totalItem {
        border-bottom: none !important;

        ::v-deep .van-field__control {
          font-size: 16px;
          color: #f46c6c;
          letter-spacing: 0;
          text-align: right;
          font-weight: 700;
        }
      }
      // ::v-deep .van-field:nth-last-child(1){
      //   .van-cell::after{
      //     border-bottom:none !important;
      //   }
      // }
    }
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 94vw;
    margin: 0 auto;
    margin-top: 20px;
    .addBtn {
      background: #2d53eb;
      border-radius: 19px;
      font-size: 15px;
      color: #ffffff;
      padding: 10px;
      left: 38px;
      display: flex;
      align-items: center;
      span {
        margin-left: 5px;
      }
    }
    > div:nth-of-type(2) {
      font-size: 12px;
      color: #333333;
      span {
        font-size: 18px;
        color: #e53500;
      }
    }
  }
  .saveBtn {
    width: 94vw;
    position: relative;
    left: 50%;
    margin-left: -47vw;
    background: #2d53eb;
    border-radius: 25px;
    line-height: 44px;
    text-align: left;
    font-size: 17px;
    font-weight: 600;
    color: #ffffff;
    margin-top: 25px;
    border: none;
  }
  .btnBox {
    // margin-top: 50px;
    ::v-deep .van-button--info {
      border: none !important;
      outline: none !important;
    }
    .btn {
      margin: 0 auto;
      width: 305px;
      background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
      border-radius: 22px;

      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 700;
      z-index: 15;
      position: relative;
      margin-top: 50px;
      .blueSha {
        z-index: 10;
        width: 266px;
        height: 34px;
        position: absolute;
        left: 50%;
        top: 68%;
        transform: translateX(-50%);
      }
    }
  }
  .notice {

    font-size: 14px;
    color: #888888;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: 400;
    span {

      font-size: 14px;
      color: #0f6cd6;
      letter-spacing: 0;
      line-height: 20px;
      font-weight: 400;
    }
  }
  .list {
    > .item {
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      position: relative;
      padding: 0px 20px;
      box-sizing: border-box;
      width: 345px;
      margin: 0 auto;
      margin-top: 15px;
      .title {
        display: flex;
        border-bottom: 1px solid #eaeaea;
        padding: 15px;
        padding-left: 0px;
        padding-right: 0px;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        font-weight: 600;
        // color: #333333;

        font-size: 14px;
        color: #464a4c;
        letter-spacing: 0;
        font-weight: 500;
        > img {
          width: 14px;
          height: 16px;
        }
      }
      .content {
        font-size: 15px;
        color: #333333;
        padding: 15px 0px;
        position: relative;
        display: flex;
        align-items: center;
        .con_left {
          width: 90%;
        }
        .con_right {
          width: 10%;

          font-size: 14px;
          color: #208fff;
          letter-spacing: 0;
          text-align: center;
          font-weight: 500;
        }
        p {
          // margin-bottom: 15px;

          font-size: 14px;
          color: #464a4c;
          letter-spacing: 0;
          line-height: 20px;
          font-weight: 400;
          span {

            font-size: 14px;
            color: #f46c6c;
            letter-spacing: 0;
            line-height: 20px;
            font-weight: 400;
          }
        }
        > img {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
  .dialog {
    width: 90vw;

    .title {
      font-size: 15px;
      font-weight: 600;
      color: #ffffff;
      width: 100%;
      text-align: center;
      line-height: 50px;
      background: #2d53eb;
      border-radius: 8px 8px 0px 0px;
    }
    .van-form {
      width: 100%;
      padding: 15px;
      box-sizing: border-box;
    }
    .btnBox {
      display: flex;
      left: 20px;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px 20px 20px;
      box-sizing: border-box;
      > div {
        width: 45%;
        border-radius: 20px;
        border: 1px solid #cccccc;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        color: #777777;
        box-sizing: border-box;
      }
      > div:nth-of-type(2) {
        background: #2d53eb;
        color: #fff;
        border: none;
      }
    }
  }
}
.fieldItem {
  position: relative;
  .paymentUnitBox {
    position: absolute;
    top: 45px;
    z-index: 100;
    width: 90%;
    left: 50%;
    margin-left: -45%;
  }
}

.dataTypeClass {
  .dTitle {
    margin-top: 30px;
    text-align: center;

    font-size: 22px;
    color: #464a4c;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: 30px;
  }
  .dWrap {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;
    padding: 0px 25px;
    box-sizing: border-box;
  }
  .dBox {
    width: 153px;
    height: 100px;
    background: rgba(32, 143, 255, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    span {

      font-size: 20px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .dBox:nth-of-type(odd) {
    width: 153px;
    height: 100px;
    margin-right: 18px;
    margin-bottom: 20px;

    background: rgba(32, 143, 255, 0.1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {

      font-size: 20px;
      color: #464a4c;
      letter-spacing: 0;
      font-weight: 500;
    }
  }
  .dBox.active {
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 10px;
    span {
      color: #fff;
    }
  }
}
</style>
